module.exports = __webpack_public_path__ + "img/user_expert_cert_bg.511189e8.png";